type GetToken = (options?: { skipCache?: boolean }) => Promise<null | string>;

export function createAuthenticatedFetch(getToken: GetToken, fetcher: typeof fetch = globalThis.fetch): typeof fetch {
  return async (input, init) => {
    const response = await fetcher(input, init);

    if (response.status !== 401) {
      return response;
    }

    let freshToken: null | string;
    try {
      freshToken = await getToken({ skipCache: true });
    }
    catch {
      return response;
    }

    if (!freshToken) {
      return response;
    }

    const headers = new Headers(input instanceof Request ? input.headers : undefined);
    new Headers(init?.headers).forEach((value, key) => headers.set(key, value));
    headers.set("Authorization", `Bearer ${freshToken}`);

    return fetcher(input, {
      ...init,
      headers,
    });
  };
}
